/* eslint-disable react-hooks/exhaustive-deps */
import { useSyncState } from "src/modules/pe-basic-module/hooks/useSyncState"
import { ILandingConsoleStore, useLandingConsoleStore } from "src/modules/pe-landing-module/data/store" 
import LayersForm from "../LayersForm"
import LandingConsoleHandler from "./LandingConsoleHandler"
import MeatForm from "../meat-form/MeatForm"

/* Protopia Ecosystem component */ 
const LandingConsole = (): JSX.Element => {
    const {
        width, isEdit, 
        isLayers, isLayersTread,
        isMeat, isMeatTread,
    } = useLandingConsoleStore(( state: ILandingConsoleStore) => state )  
    const console_width = useSyncState<number>( width )

    const setConsoleWidth = (width: number) => {
        console_width.set( width )
    }
    const updateConsoleWidth = () => { 
        useLandingConsoleStore.setState({ width: console_width.get() })
    }
    // useEffect(() => useLandingConsoleStore.subscribe( ( state: ILandingConsoleStore ) => console_width.set( state.width ) ), [])
 
    const realWidth = !!fillLandingConsole().length ? console_width.get() : 0
    return <div className="landing-console-panel" style={{width: realWidth, minWidth: realWidth, }}>
        <LandingConsoleHandler 
            console_width={ console_width.get() } 
            setConsoleWidth={ setConsoleWidth } 
            updateConsoleWidth={updateConsoleWidth}
        />
        <div className="landing-console-panel-content " style={{width: realWidth - 8, minWidth: realWidth - 8, }}> 
            {
                isEdit && isLayers && !!isLayersTread &&
                <LayersForm />
            }
            {
                isEdit && isMeat && !!isMeatTread &&
                <MeatForm />
            }
        </div>
        
    </div>
}
export default LandingConsole

const panels: any[] = [
    {
        c: LayersForm,
        title: "Sections",
        isEnabled: "isLayers",
        isTread: "isLayersTread"
    },
    {
        c: MeatForm,
        title: "Meat",
        isEnabled: "isMeat",
        isTread: "isMeatTread"
    },
]
export const fillLandingConsole = () : any[] => {
    return panels.filter(p => {
        const isEnabled = useLandingConsoleStore.getState()[p.isEnabled]
        const isTread = useLandingConsoleStore.getState()[p.isTread]
        return isTread && isEnabled
    })
}